import { useEffect } from 'react';
import { initGoogleAnalytics, subscribeScrollDepth75 } from '@/lib/gtag';

/** Initializes GA4 and one-time scroll-depth tracking. Renders nothing. */
const GoogleAnalytics = () => {
  useEffect(() => {
    initGoogleAnalytics();
  }, []);

  useEffect(() => {
    return subscribeScrollDepth75();
  }, []);

  return null;
};

export default GoogleAnalytics;
